import { DEFAULT_DESIGNS_SORT_ORDER } from 'settings';

const HARD_CODED_NEW_IN_CATEGORY_ID = 2753;
const HARD_CODED_BESTSELLERS_CATEGORY_ID = 2754;

const getDefaultSortOrderByCategoryId = (categoryId: number) => {
  switch (categoryId) {
    case HARD_CODED_NEW_IN_CATEGORY_ID:
      return 2;
    case HARD_CODED_BESTSELLERS_CATEGORY_ID:
      return 1;
    default:
      return DEFAULT_DESIGNS_SORT_ORDER;
  }
};

export default getDefaultSortOrderByCategoryId;
